export default __webpack_public_path__ + "65ba521005ba76af5c9e9ee88a48c4c0.png";